export enum MLEventType {
  CLICK = 'C', // Click type event where the user clicked on a search result
  IMPRESSION = 'I', // Impression event where one or more product cards become visible to an athlete on a search/family page
  PINNED_CONTENT_SPOTS = 'PCL', // list of Pinned Content Spot
  SEARCH = 'S', // Search type event where a search was performed and results were displayed
  SPONSORED_PRODUCTS = 'SPL', // list of Sponsored Products
  TEST = 'T', // Test event, should be ignored
  VIEW = 'V' // Impression event where one or more product cards become visible to an athlete on a search/family page
}
